import { render } from "./FormOrderable.vue?vue&type=template&id=6ecf4547&scoped=true&ts=true"
import script from "./FormOrderable.vue?vue&type=script&lang=ts"
export * from "./FormOrderable.vue?vue&type=script&lang=ts"

import "./FormOrderable.vue?vue&type=style&index=0&id=6ecf4547&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ecf4547"]])

export default __exports__